module.exports = __webpack_public_path__ + "img/home.8ae5e939.svg";